<div class="flex flex-col h-full overflow-hidden">
   <topbar
      [userName]="(user$ | async)?.name"
      [userRole]="(user$ | async)?.role"
      (logout)="auth.logout()"
      (goToMyProjects)="$app.core.goToMyProjects()"
      (goToEditAccount)="$app.core.goToEditAccount()"
      (goToCreateProject)="$app.core.goToCreateProject()"
      (goToChangePassword)="$app.core.goToChangePassword()"
   ></topbar>

   @if (!isError) {
      <status-topbar
         class="basic-shadow"
         [project]="project$ | async"
         [allowEdit]="(project$ | async)?.permission?.type == 'WRITE'"
      ></status-topbar>
   }

   <div class="flex-1 min-h-0 overflow-hidden bg-app-gray-3 basic-shadow">
      <div class="grid grid-cols-[auto,1fr] h-full min-h-0 basic-shadow">
         <div class="h-full overflow-auto">
            @if (!isError) {
               <navbar
                  [isSidebarOpen]="isSidebarOpen$ | async"
                  class="h-full"
               ></navbar>
            }
         </div>
         <div class="bg-app-light-gray min-w-0 h-full overflow-auto basic-shadow {{ isError ? 'p-0' : 'p-5' }}">
            <router-outlet></router-outlet>
         </div>
      </div>
   </div>

   <footerbar></footerbar>
</div>

<simple-notifications></simple-notifications>
